export const light = {
    alternate: {
        main: '#f0f4ff',
        dark: '#e6efff',
    },
    cardShadow: 'rgba(37, 99, 235, .11)',
    mode: 'light',
    primary: {
        main: '#2563eb',
        light: '#3b82f6',
        dark: '#1e40af',
        contrastText: '#fff',
    },
    secondary: {
        light: '#22c55e',
        main: '#22c55e',
        dark: '#22c55e',
        contrastText: '#ffffff',
    },
    text: {
        primary: '#0b0f19',
        secondary: '#565973',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
        paper: '#fff',
        default: '#fff',
        level2: '#f5f5f5',
        level1: '#fff',
    },
};

export const dark = {
    alternate: {
        main: 'rgba(255, 255, 255, .04)',
        dark: 'rgba(255, 255, 255, .04)',
    },
    cardShadow: 'rgba(0, 0, 0, .11)',
    common: {
        black: '#000',
        white: '#fff',
    },
    mode: 'dark',
    primary: {
        main: '#3b82f6',
        light: '#60a5fa',
        dark: '#2563eb',
        contrastText: '#fff',
    },
    secondary: {
        light: '#22c55e',
        main: '#22c55e',
        dark: '#22c55e',
        contrastText: '#ffffff',
    },
    text: {
        primary: '#ffffff',
        secondary: '#eff2fc',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#222B45',
        default: '#222B45',
        level2: '#333',
        level1: '#2D3748',
    },
};
